import { IBookFields } from 'marketing-site/@types/generated/contentful'
import { marketoFormIds } from 'marketing-site/lib/marketo'
import { MarketoFormV2 } from 'marketing-site/src/library/components/MarketoFormV2'
import { CTALink } from 'marketing-site/src/library/elements/CTALink'
import { Text } from 'marketing-site/src/library/elements/Text'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'
import { CTATheme } from 'marketing-site/src/library/utils'
import React, { useState } from 'react'

interface IFormProps {
  downloadUrl: string
  downloadText: string
  resourceType: IBookFields['resourceType']
}

export const testIds = {
  form: 'test-resources-hero-form',
  downloadLink: 'test-resources-hero-form-download-link',
}

export function BookOrGuideForm({ downloadUrl, downloadText, resourceType }: IFormProps) {
  const [submitted, setSubmitted] = useState(false)
  const { translate } = useTranslate()
  return (
    <div className="book-guide-download-form" data-testid={testIds.form}>
      {!submitted ? (
        <div className="book-marketo-form mkto-form-wrapper">
          <div className="book-marketo-form-header">
            <Text size="xl+">{translate('Get your copy')}</Text>
            <p>{translate('Enter your information below to read the content')}</p>
          </div>
          <MarketoFormV2
            formId={marketoFormIds.books}
            submitButtonLabel="Download now"
            onSubmit={(response) => response.success && setSubmitted(true)}
            forceBusinessEmail={false}
          />
        </div>
      ) : (
        <div className="book-success-state" data-testid={testIds.downloadLink}>
          <p className="text">{translate('Thanks! Your copy is ready.')}</p>
          <CTALink
            bgColor={CTATheme.BlackFill}
            url={downloadUrl}
            text={downloadText}
            newWindow={true}
            eventContext={resourceType}
            eventObjectName="download_button"
          />
        </div>
      )}
      <style jsx>{`
        .book-marketo-form-header {
          text-align: center;
          padding: 3.75rem 1.875rem 0;

          :global(p) {
            margin-top: 1.25rem;
          }
        }

        .book-marketo-form {
          :global(.book-marketo-form-header + .form-element-wrapper) {
            padding: 1.875rem;
          }
        }

        .book-success-state {
          padding: 40px 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }

        .text {
          padding-bottom: 25px;
        }
      `}</style>
    </div>
  )
}
